import {
  ActionContext,
  ActionTree,
  GetterTree,
  Module,
  MutationTree
} from "vuex";
import { RootState } from "../store";
import configUseCases from "../../../../domain/usecase/impl/config/configUseCases";
import { Config } from "../../../../domain/entities/config";
import { ListPickerState } from "./list_picker_module";

class ConfigState {
  config: Config = new Config();
}

const state = new ConfigState();

const mutations: MutationTree<ConfigState> = {
  SET_CONFIG(state: ConfigState, config: Config): void {
    state.config = config;
  }
};

const actions: ActionTree<ConfigState, RootState> = {
  async get({
    commit
  }: ActionContext<ConfigState, RootState>): Promise<Config> {
    try {
      const response: Config = await configUseCases.get();
      commit("SET_CONFIG", response);
      return response;
    } catch (e) {
      commit("SET_CONFIG", new Config());
      console.log(e);
      throw e;
    }
  }
};

const getters: GetterTree<ConfigState, ConfigState> = {
  isMaintenance(state: ConfigState): boolean {
    return state.config.enabled;
  }
};


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} as Module<ConfigState, RootState>;
